export default function ClientInvoices() {
  return (
    <section className="flex flex-col gap-4 align-middle items-center">
      <h1>Invoices Page</h1>
      <p>Coming Soon</p>
    </section>
  );
}
